<template>
  <div class="app__steps">
    <div :class="{'app__step': true}" v-for="step in maxSteps">
      <button :class="{'app__stepDot': true, 'active': step === parseInt(activeStep)}"
              @click="setStep(step)"
              v-if="parseInt(activeStep) >= step"></button>
      <div class="app__stepDot" v-else></div>
    </div>
  </div>
</template>

<script>
import EventBus from "../../event-bus";

export default {
  name: "Steps",
  props: ['steps', 'maxSteps', 'activeStep'],
  data: () => ({}),
  methods: {
    setStep(step) {
      const index = this.steps.findIndex((el) => {
        return parseInt(el.step_number) === step
      });

      EventBus.$emit('SET_STEP', index);
    }
  }
}
</script>

<style scoped>

</style>